import CloseButton from '../CloseButton'
import { FontFamilies } from '../constants'

import './style.styl'

const TakeoverPreview = ({ message, headline, ctaCopy, backgroundColor = "000000", showCta = true, fontFamily = 'Arial' }) => (
  <div className="takeover-preview--root" style={{ fontFamily: FontFamilies[fontFamily] }}>
    <div className="takeover-preview--content">
      <CloseButton/>
      <div className="takeover-preview--text">
        <h2 className="takeover-preview--headline">
          { headline }
        </h2>
        <p className="takeover-preview--copy" dangerouslySetInnerHTML={{ __html: message }}/>
      </div>
      { showCta &&
        <div className="takeover-preview--cta" style={{ background: `#${backgroundColor}`}}>
          {ctaCopy}
        </div>
      }
    </div>
  </div>
)

export default TakeoverPreview


// WEBPACK FOOTER //
// ./src/scripts/components/shared/PlaybookPreviews/Takeover/index.js